module.exports = __webpack_public_path__ + "img/1528696218.fbc40b13.jpg";